export const STATE_KEYS = [
    'selectedClientId',
    'pads',
    'selectedRightBarIdx',
    'tradingLayoutHeight',
    'clickMode',
    'tradingEnabled',
    'spotColumnState',
    'forwardColumnState',
    'pendingColumnState',
    'kondorColumnState',
    'positionColumnState',
    'spotFilterModel',
    'forwardFilterModel',
    'pendingFilterModel',
    'isColumnFilteringEnabled',
    'blotterSearchFilter',
    'blotterSelectedTab',
    'selectedNotificationFilter',
    'selectedSetting',
    'tradingQuantities',
    'selectedLimit',
] as const;

export type EStateKeys = typeof STATE_KEYS[number];
